import { Facebook, Instagram } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollToHash } from "@/utils/scroll";
import { useLang } from "@/i18n";

const LINKS = [
    { hash: "#inicio", id: "inicio" },
    { hash: "#nosotros", id: "nosotros" },
    { hash: "#habitaciones", id: "habitaciones" },
    { hash: "#resenas", id: "resenas" },
    { hash: "#contacto", id: "contacto" },
];

export default function Footer() {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const { t } = useLang();

    const go = (hash) => {
        if (pathname !== "/") {
            navigate("/");
            setTimeout(() => scrollToHash(hash), 350);
        } else {
            scrollToHash(hash);
        }
    };

    return (
        <footer data-testid="site-footer" className="bg-olive-deep text-cream">
            <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-3 md:px-12 md:py-20">
                <div>
                    <div className="flex items-center">
                        <img
                            src="/fotos/logo-horizontal.png"
                            alt="Hotel Punta Palmeras — Bungalows & Hotel"
                            width="341"
                            height="120"
                            className="h-10 w-auto brightness-0 invert"
                        />
                    </div>
                    <p className="mt-4 max-w-xs text-sm font-light leading-relaxed text-cream/70">
                        {t.footer.tagline}
                    </p>
                    <div className="mt-6 flex gap-4">
                        <a
                            href="https://www.facebook.com/HotelPuntaPalmeras"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Facebook del hotel"
                            data-testid="footer-social-facebook"
                            className="rounded-full border border-cream/20 p-2.5 text-cream/80 transition-colors duration-300 hover:border-amber-soft hover:text-amber-soft"
                        >
                            <Facebook className="h-4 w-4" strokeWidth={1.5} />
                        </a>
                        <a
                            href="https://www.instagram.com/hotelpuntapalmeras/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram del hotel"
                            data-testid="footer-social-instagram"
                            className="rounded-full border border-cream/20 p-2.5 text-cream/80 transition-colors duration-300 hover:border-amber-soft hover:text-amber-soft"
                        >
                            <Instagram className="h-4 w-4" strokeWidth={1.5} />
                        </a>
                    </div>
                </div>

                <nav aria-label="Enlaces rápidos">
                    <h3 className="text-xs font-medium uppercase tracking-[0.28em] text-amber-soft">{t.footer.quick}</h3>
                    <ul className="mt-5 space-y-3">
                        {LINKS.map((l) => (
                            <li key={l.id}>
                                <button
                                    type="button"
                                    onClick={() => go(l.hash)}
                                    data-testid={`footer-link-${l.id}`}
                                    className="text-sm font-light text-cream/75 transition-colors duration-300 hover:text-amber-soft"
                                >
                                    {t.nav[l.id]}
                                </button>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div>
                    <h3 className="text-xs font-medium uppercase tracking-[0.28em] text-amber-soft">{t.footer.policiesTitle}</h3>
                    <ul className="mt-5 space-y-3 text-sm font-light text-cream/75">
                        {t.footer.policies.map((p, i) => (
                            <li key={i}>{p}</li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="border-t border-cream/10">
                <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-6 py-6 text-xs font-light text-cream/50 md:flex-row md:px-12">
                    <p>{t.footer.rights}</p>
                </div>
            </div>
        </footer>
    );
}
